/* no babel so we have to use old js syntax */
window.Popper = require('popper.js');
require('bootstrap');

import "@fontsource/bebas-neue/latin.css";
import "@fontsource/roboto-condensed/latin.css";
import "@fontsource/cabin-condensed/latin.css";
import "@fontsource/poppins/latin.css";

;$(function() {
  var $hamburger = $(".hamburger");
  $hamburger.on("click", function (e) {
    $hamburger.toggleClass("is-active");
    document.querySelector('body>header').classList.toggle('h-auto')
  });

  /* ajax-form-submission
  var form = $('#contact');
  if(typeof form != 'undefined') {
    $(form).on('submit', function(e) {
      e.preventDefault();
      $('#form-response').html('');
      $(".loader").css('opacity', '1');
      $(".loader").css('opacity', '1');
      $(form).find(':submit').attr('disabled', 'disabled');

      // submit the form via Ajax
      $.ajax({
        url: form.attr('action'),
        type: form.attr('method'),
        data: form.serialize(),
        success: function(result) {
          if ($(result).text().indexOf("Dank") != -1)
          {
            $('#form-response').html(result);
            $(".loader").css('opacity', '0');
            $(form).fadeOut().remove();
          } else {
            $('#form-response').html(result);
            $(form).find(':submit').removeAttr('disabled');
            $(".loader").css('opacity', '0');
          }
        }
      });
    });
  }
  */

});



//////////////////
// WEBPACK FOOTER
// ./js/theme.js
// module id = 2
// module chunks = 0